export const HEIGHTS = {
    initialState: {
        sm: {
            height: '264px',
        },
        md: {
            height: '272px',
        },
        lg: {
            height: '344px',
        },
    },
    withDealerCards: {
        sm: {
            height: '520px',
        },
        md: {
            height: '512px',
        },
        lg: {
            height: '616px',
        },
    },
};
export const FORM_STYLE_PARAMETERS = {
    sm: {
        minHeight: '144px',
    },
    md: {
        minHeight: '148px',
    },
    lg: {
        minHeight: '169px',
    },
};
